import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SegurosApiService } from '../api/seguros-api.service';
import { BuscarSolicitud, Solicitud } from '../../model/solicitud.model';

@Injectable({
  providedIn: 'root'
})
export class SolicitudStoreService {
  private solicitudesSubject = new BehaviorSubject<Solicitud[]>([]);
  solicitudes$ = this.solicitudesSubject.asObservable();

  private busquedaSubject = new BehaviorSubject<BuscarSolicitud | null>(null);
  busqueda$ = this.busquedaSubject.asObservable();

  constructor(private segurosService: SegurosApiService) {}

  getSolicitudes(busqueda: BuscarSolicitud): void {
    this.busquedaSubject.next(busqueda); 
    this.segurosService.getSolicitudes(busqueda).subscribe({
      next: (solicitudes) => {
        this.solicitudesSubject.next(solicitudes);
      },
      error: (err) => console.error('Error fetching solicitudes:', err),
    });
  }

  limpiarSolicitudes(): void {
    this.solicitudesSubject.next([]);
  }
  
  limpiarBusqueda(): void {
    this.busquedaSubject.next(null);
  }
}

